<template lang="pug">
.WtActionMenuItem
  .level
    .level-left
      .level-item
        BIcon(:icon="icon")
      .level-item
        span {{ text }}

</template>

<script>
export default {
  name: "WtActionMenuItem",

  props: {
    icon: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="sass" scoped>
.level:not(.top)
  padding: 0 !important
</style>
